import React from 'react';
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {Card, Col, Row} from "antd";
import {Can} from "@/components/can/Can";
import {Link} from "react-router-dom";
import PermList from "@/lib/helper/PermList";

function AdminProductDashboard(props) {

    const navCards = [
        {
            title: 'محصولات',
            icon: <span className={'icon-tags text-blue-700 text-3xl'}/>,
            link: URLS.admin.products.list,
            can: PermList.PRODUCT_LIST
        },
        {
            title: 'لیست کلی افراد',
            icon: <span className={'icon-users-line text-blue-700 text-3xl'}/>,
            link: URLS.admin.products.members,
            can: PermList.PRODUCT_DELIVERY_STEP_ADD
        },
        {
            title: 'گروه های تحویل',
            icon: <span className={'icon-list-check text-blue-700 text-3xl'}/>,
            link: URLS.admin.products.delivery.list,
            can: PermList.PRODUCT_DELIVERY_STEP_LIST
        },
        {
            title: 'لیست تحویل اقلام',
            icon: <span className={'icon-list text-blue-700 text-3xl'}/>,
            link: URLS.admin.products.delivery.receipt,
            can: PermList.PRODUCT_DELIVERY_LIST
        },
        {
            title: 'صدور رسید تحویل اقلام',
            icon: <span className={'icon-print text-blue-700 text-3xl'}/>,
            link: URLS.admin.products.delivery.searchForPrint,
            can: PermList.PRODUCT_DELIVERY_RECEIPT
        },
        {
            title: 'تحویل فیزیکی اقلام',
            icon: <span className={'icon-bag-shopping text-blue-700 text-3xl'}/>,
            link: URLS.admin.products.delivery.searchForDeliver,
            can: PermList.PRODUCT_DELIVERY_DELIVER
        },
        {
            title: 'صدور رسید تحویل اقلام به مربیان',
            icon: <span className={'icon-print text-blue-700 text-3xl'}/>,
            link: URLS.admin.products.delivery.printToLesson,
            can: PermList.PRODUCT_DELIVERY_RECEIPT
        },
        {
            title: 'تحویل اقلام به مربیان',
            icon: <span className={'icon-bag-shopping text-blue-700 text-3xl'}/>,
            link: URLS.admin.products.delivery.deliverToLesson,
            can: PermList.PRODUCT_DELIVERY_DELIVER
        },
    ]
    return (
        <AdminLayout backTo={URLS.admin.dashboard} pageTitle={'سامانه تحویل اقلام آموزشی'}>

            {/* Navigation Cards */}
            <Row gutter={[24, 24]} justify="" className={'mb-4'}>
                {navCards.map((card, index) => (
                    <Can permission={card?.can}>
                        <Col xs={24} sm={12} md={8} lg={6} key={index + 'admin-dashboard-menu'}>

                                <Link to={card.link}>
                                    <Card hoverable className={'text-center rounded-2xl'}>
                                        {card.icon}
                                        <div className={'mt-2 font-bold text-l'}>{card.title}</div>
                                    </Card>
                                </Link>


                        </Col>
                    </Can>
                ))}
            </Row>
        </AdminLayout>
    );
}

export default AdminProductDashboard;